import { Link } from "react-router-dom";
import { CalendarDays, Newspaper, PlayCircle, Star } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export function newsExcerpt(body, len = 120) {
  if (!body) return "";
  const t = body
    .replace(/\[\[(?:img|video):[^\]]+\]\]/g, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return t.length > len ? `${t.slice(0, len).trim()}…` : t;
}

export function PublicNewsCard({ item }) {
  return (
    <Link
      to={`/notizia/${item.id}`}
      data-testid={`public-news-${item.id}`}
      className="group rounded-xl border border-white/10 bg-[#0F172A] overflow-hidden hover:border-gold/40 transition-colors flex flex-col"
    >
      <div className="relative w-full h-44 bg-[#0B1220] overflow-hidden">
        {item.image_url ? (
          <img src={mediaUrl(item.image_url)} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" style={{ objectPosition: item.image_position || "50% 50%" }} />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gold/30"><Newspaper className="w-10 h-10" /></div>
        )}
        {item.video_url && (
          <span className="absolute bottom-2 right-2 w-9 h-9 rounded-full bg-black/60 text-white flex items-center justify-center"><PlayCircle className="w-5 h-5" /></span>
        )}
        {item.featured && (
          <span className="absolute top-2 left-2 inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-full bg-gold text-[#020617]"><Star className="w-3 h-3" fill="currentColor" /> In evidenza</span>
        )}
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <h3 className="font-semibold text-lg leading-snug group-hover:text-gold transition-colors break-words">{item.title}</h3>
        <p className="text-sm text-muted-foreground mt-2 flex-1">{newsExcerpt(item.body)}</p>
        <span className="flex items-center gap-1.5 text-xs text-muted-foreground mt-4"><CalendarDays className="w-3.5 h-3.5 text-gold" />{new Date(item.created_at).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</span>
      </div>
    </Link>
  );
}
